export default __webpack_public_path__ + "static/media/bigLogo.f2ddbd64.svg";